//export {default as IconBlur} from './components/IconBlur';
//export {default as Agent} from './components/Agent';
//export {default as DebugView} from './components/DebugView';

export * from "./components/QANote";

import QANote from "./components/QANote";

export default QANote;
